var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 28,
    viewBox: "0 0 75 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.2692 0 0 6.2692 0 14C0 21.7308 6.2692 28 14 28C21.7308 28 28 21.7308 28 14C28 6.2692 21.7308 0 14 0ZM9.93176 21.1641H6.52213V10.9061H9.93176V21.1641ZM8.22705 9.50537H8.20483C7.06067 9.50537 6.32068 8.71774 6.32068 7.73337C6.32068 6.72678 7.08331 5.96094 8.24969 5.96094C9.41608 5.96094 10.1339 6.72678 10.1561 7.73337C10.1561 8.71774 9.41608 9.50537 8.22705 9.50537ZM22.2262 21.1641H18.817V15.6763C18.817 14.2971 18.3233 13.3566 17.0896 13.3566C16.1478 13.3566 15.5868 13.991 15.3403 14.6035C15.2501 14.8227 15.2281 15.129 15.2281 15.4355V21.1641H11.8187C11.8187 21.1641 11.8633 11.8685 11.8187 10.9061H15.2281V12.3585C15.6812 11.6595 16.4919 10.6653 18.3009 10.6653C20.5441 10.6653 22.2262 12.1314 22.2262 15.2822V21.1641Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 14C75 21.732 68.732 28 61 28C53.268 28 47 21.732 47 14C47 6.26801 53.268 0 61 0C68.732 0 75 6.26801 75 14ZM59.0678 14.8364L52.376 5.88897H57.5336L61.9206 11.7548L67.3501 5.88897H68.8658L62.5977 12.6605L69.6662 22.1111H64.5087L59.7453 15.7419L53.8495 22.1111H52.3338L59.0678 14.8364ZM56.9742 7.0053H54.6049L65.0677 20.9948H67.4371L56.9742 7.0053Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon3);
export default __webpack_public_path__ + "static/media/footer_icon3.84f28fe6dec255eff0199b65b5ef6086.svg";
export { ForwardRef as ReactComponent };